import {ThreeDotsLoader} from '@chekinapp/ui';

export const AuthPageLoader = () => {
  return (
    <div className="absolute inset-0 z-[2] flex items-center justify-center">
      <ThreeDotsLoader color="var(--primary)" width={60} height={60} />
    </div>
  );
};
